import React from "react";
import success from "../../../../assets/success.png";
import { Box, Button, Modal, Typography } from "@mui/material";
import "./AddBusiness.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  background: "white",
  padding: "24px 30px",
  borderRadius: "24px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "252px",
};

function SuccessModal({ open, handleClose, title,message }) {
  return (
    <Modal open={open}>
      <Box style={style}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img src={success} width="55px" height="55px" />
          <Typography
            sx={{
              color: "rgba(14, 58, 83, 1)",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Success
          </Typography>
        </Box>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: "600",
            color: "rgba(14, 58, 83, 1)",
            textAlign: "center",
          }}

        >
          {message}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button className="success-button" onClick={() => handleClose()}>
            {title}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default SuccessModal;
